/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Members_Manage_MembersInputs */

const en_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage members`)
};

const de_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder verwalten`)
};

const es_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar miembros`)
};

const fr_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les membres`)
};

const it_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci membri`)
};

const pt_br2_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar membros`)
};

const pl_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj członkami`)
};

const hu_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagok kezelése`)
};

const ro_admin_dashboard_empty_state_members_manage_members = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionati membrii`)
};

/**
* | output |
* | --- |
* | "Manage members" |
*
* @param {Admin_Dashboard_Empty_State_Members_Manage_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_members_manage_members = /** @type {((inputs?: Admin_Dashboard_Empty_State_Members_Manage_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Members_Manage_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_members_manage_members(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_members_manage_members(inputs)
	return ro_admin_dashboard_empty_state_members_manage_members(inputs)
});
export { admin_dashboard_empty_state_members_manage_members as "admin.dashboard.empty_state.members.manage_members" }